module.exports = __webpack_public_path__ + "static/media/23.e9815616.png";